__turbopack_context__.v({
  "hero-image": "personal-plan-module-module-scss-module__HlLTQa__hero-image",
  "pp-info-module": "personal-plan-module-module-scss-module__HlLTQa__pp-info-module",
  "pp-info-module-button": "personal-plan-module-module-scss-module__HlLTQa__pp-info-module-button",
  "pp-info-module-button-text": "personal-plan-module-module-scss-module__HlLTQa__pp-info-module-button-text",
  "pp-info-module-description": "personal-plan-module-module-scss-module__HlLTQa__pp-info-module-description",
  "pp-info-module-title": "personal-plan-module-module-scss-module__HlLTQa__pp-info-module-title",
  "pp-module": "personal-plan-module-module-scss-module__HlLTQa__pp-module",
});
